import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { getProjectRatings } from '../app/apis/subRatingsAPI';
import { IRating } from '../app/interfaces/IRating';
import { IQueryParams, IQueryState } from '../app/interfaces/ISortableTable';
import { ISearchableResponse } from '../app/interfaces/IApiResponses';

type State = {
  data: IRating[];
  // `undefined` rather than `null`, matching IEntityState and every other
  // slice - SortableTable takes an optional queryState, so a null here is the
  // one value it will not accept.
  queryState: IQueryState | undefined;
};

const initialState: State = {
  data: [],
  queryState: undefined,
};

export const getProjectRatingsThunk = createAsyncThunk<
  ISearchableResponse<IRating[]>,
  { companyId: number; projectId: number; queryParams?: IQueryParams }
>('projectRatings/get', async ({ companyId, projectId, queryParams }) => {
  return await getProjectRatings(companyId, projectId, queryParams);
});

const slice = createSlice({
  name: 'projectRatings',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getProjectRatingsThunk.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.queryState = action.payload.queryState;
    });
  },
});

export const selectProjectRatings = (state: RootState) => state.projectRatings.data;
export const selectProjectRatingsState = (state: RootState) => state.projectRatings;
export default slice.reducer;